import React from 'react';
export const InfoList = ({ infoList }) => (<React.Fragment>
    {infoList.map((item) => <p key={item}><strong>{item}</strong></p>)}
  </React.Fragment>);
export default InfoList;
